import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Injectable } from '@angular/core';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { HotelSearchServiceHandler } from '@tc-core/service/service-handlers';
import { SurfTariffSearchService } from '../surf-tariff-search.service';
import { Utils } from '../utils/utils';
import { SurfFileDownloadHelperService } from '@surf/surf-components-core';

@Injectable({
  providedIn: 'root',
})
export class TariffApiService {
  constructor(
    private hotelSearchServiceHandler: HotelSearchServiceHandler,
    private surfTariffSearchService: SurfTariffSearchService,
    private fileDownloadService: SurfFileDownloadHelperService,
  ) {}

  public downloadTariffHotelResultsFile(parameters, requestBody, docType): any {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-api.service.ts.TariffApiService.downloadTariffHotelResultsFile');
    const keyParams = Utils.keyParmToObj(parameters);
    const criteria = this.surfTariffSearchService.getTariffHotelCriteriaValue();
    keyParams.noOfResults = criteria.noOfResults;
    keyParams.rowId = criteria.rowId;
    keyParams.docType = docType?.toLowerCase();
    keyParams.from = criteria.hotelFromDate.split('/').reverse().join('-');
    keyParams.to = criteria.hotelToDate.split('/').reverse().join('-');
    keyParams.currency = criteria.hotelCurrency;
    const body = requestBody?.map((item) => {
      return {
        ...item.response,
      };
    });

    this.hotelSearchServiceHandler
      .downloadHotelTariffDocument(keyParams, body)
      .subscribe((res: any) => {
        if (res && !(res instanceof TcHttpError)) {
          this.fileDownloadService.downloadFile(
            docType,
            `Tariff_Document`,
            true,
            {
              base64StrArray: res?.data?.map((item) => {
                return item?.document;
              }),
            }
          );
        }
      });
  }

  public searchTariffHotelCriteria(tariffHotelCriteria, keyParams): any {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-api.service.ts.TariffApiService.searchTariffHotelCriteria');
    // make request to server
    this.surfTariffSearchService.setLoadingResult(true);
    const keyParamObj = Utils.keyParmToObj(keyParams);
    delete keyParamObj.resultsCount;
    const requestPayload = this.mapToTariffHotelCriteria(
      tariffHotelCriteria,
      keyParamObj
    );

    this.hotelSearchServiceHandler
      .getHotelTariffResults(requestPayload)
      .subscribe((res: any) => {
        if (res && !(res instanceof TcHttpError)) {
          const resultList = this.mapToTariffResultTable(res);
          this.surfTariffSearchService.setTariffHotelResults(resultList);
          this.surfTariffSearchService.setTariffHotelCriteria(
            tariffHotelCriteria
          );
          this.surfTariffSearchService.setLoadingResult(false);
        } else if (res instanceof TcHttpError) {
          this.surfTariffSearchService.setLoadingResult(false);
        }
      });
  }

  private mapToTariffHotelCriteria(tariffHotelCriteria, keyParams): any {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-api.service.ts.TariffApiService.mapToTariffHotelCriteria');
    return {
      ...keyParams,
      hotelCurrency: tariffHotelCriteria.hotelCurrency,
      hotelCountry: tariffHotelCriteria.hotelCountry,
      hotelName: tariffHotelCriteria.hotelName,
      hotelFromDate: this.convertDateFormat(tariffHotelCriteria.hotelFromDate),
      hotelToDate: this.convertDateFormat(tariffHotelCriteria.hotelToDate),
      hotelTariffYear: this.getTariffYearFromHotelFromDate(tariffHotelCriteria.hotelFromDate),
      hotelCity: tariffHotelCriteria.hotelCity,
      noOfResults: tariffHotelCriteria.noOfResults,
      rowId: tariffHotelCriteria.rowId,
    };
  }

  private mapToTariffResultTable(res): any {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-api.service.ts.TariffApiService.mapToTariffResultTable');
    return res?.data?.map((item) => {
      return {
        name: item.hotelName,
        city: item.city,
        resort: item.resort,
        touristRegion: item.touristRegion,
        starRating: item.starRating,
        ourRating: item.inHouseRating,
        response: item,
      };
    });
  }

  private convertDateFormat(date): any {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-api.service.ts.TariffApiService.convertDateFormat');
    // convert date format from dd/mm/yyyy to yyyy-MM-dd
    return date.split('/').reverse().join('-');
  }

  private getTariffYearFromHotelFromDate(hotelFromDate): any {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-api.service.ts.TariffApiService.getTariffYearFromHotelFromDate');
    return hotelFromDate.split('/')[2];
  }
}
